// /calls 검색 필드 정의 (SearchToolbar config).
// 기존 인라인 <TextField> 5개를 이 배열 하나로 대체한다. field 키 / operator / 옵션값 동일.

import type { SearchFieldConfig } from "components/list";

export const callsSearchFields: SearchFieldConfig[] = [
  { name: "id", label: "ID", type: "text", operator: "contains", width: 140 },
  {
    name: "in_out",
    label: "IN/OUT",
    type: "select",
    operator: "eq",
    width: 160,
    options: [
      { value: "", label: "전체" },
      { value: "IN", label: "IN" },
      { value: "OUT", label: "OUT" },
      { value: "ILUVIT", label: "ILUVIT" },
    ],
  },
  { name: "centerId", label: "시설ID", type: "text", operator: "contains", width: 160 },
  { name: "m_email", label: "이메일", type: "text", operator: "contains", width: 200 },
  {
    name: "participation",
    label: "참여상태",
    type: "select",
    operator: "eq",
    width: 160,
    options: [
      { value: "", label: "전체" },
      { value: "PARTICIPATION", label: "참여" },
      { value: "COMPLETED", label: "완료" },
      { value: "HOLD", label: "보류" },
      { value: "ABSENCE", label: "부재" },
      { value: "REJECT", label: "거절" },
    ],
  },
];
